import moment from "moment";
import apiService from "./api.service";
import { downloadExcelBlobFromUrl } from "./excelBlobDownload.service";

const pathPrefix = `${process.env.REACT_APP_SERVER_URL}/api`;

class ReportsService {

    fetchReportBase(path: string, filename: string, setIsLoading: (value: boolean) => void) {
      const genericError = "Nie udało się wygenerować raportu.";
      void downloadExcelBlobFromUrl({
        url: path,
        fallbackDownloadName: `${filename}${moment().format("DDMMYYYYhhmmss")}.xlsx`,
        setIsLoading,
        genericErrorMessage: genericError,
      });
    }

    extractDateParts = (dateString: string) => {
      const year = moment(dateString).year().toString();
      const rest = dateString.substring(5);

      const match = rest.match(/^(?:(\d{2})|W(\d{2})|(\d{2})-(\d{2}))$/);
      if (!match) throw new Error('Invalid date format');
    
      const [, month, week, monthPart, day] = match;
      return { year, month: month || monthPart, week, day };
    };

    removeLeadingZeros = (str: string): string => str.replace(/^0+/, '');

    generateWorktimeReport(
        dateValue: string,
        setIsLoading: (value: boolean) => void,
        userId?: string,
    ) {
        let pathSuffix = userId ? `/reports/worktime-per-user` : `/reports/worktime-cumulative`;
        let path = `${pathPrefix}${pathSuffix}`;
        const params = [];
        const { year, month, day, week } = this.extractDateParts(dateValue);

        if (userId) params.push({ key: "userId", value: userId });
        if (year)   params.push({ key: "year",   value: year });
        if (month)  params.push({ key: "month",  value: month });
        if (day)    params.push({ key: "day",    value: day });
        if (week)   params.push({ key: "week",   value: week });

        if (params.length > 0) {
          path = apiService
            .setPathParams(path, params)
            .replace('&', '?');
        }

        this.fetchReportBase(
          path,
          userId ? "RaportPracownika_" : "RaportZbiorczy_",
          setIsLoading
        );
    }
}

const reportsService = new ReportsService();
export default reportsService;
